import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Cookies from "js-cookie";

import * as AuthServices from '../../services/auth.service';
import { ATLEAST_ONE_CAPITAL_REGEX, ATLEAST_ONE_NUMBER_REGEX, ATLEAST_ONE_SMALL_REGEX, ATLEAST_ONE_SPECIAL_CHARACTER_REGEX, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, ROLE, SWAL_SETTINGS } from "../../../../utils/Constants";
import { PHONE_VALIDATION } from "../../../../utils/CommonValidatiobn";
import Swal from "sweetalert2";
import { clearUserSession, handleServerValidations, removeSessionKey, setLocalKey, setSessionKey, isMissingPhoneNumber } from "../../../../utils/commonfunction";
import { useDispatch } from "react-redux";
import { addProfileData } from "../../../../redux/slices/profileslice";
import { useNavigate, useSearchParams } from "react-router-dom";
import PhoneInput from "../../../../utils/PhoneInput";
import GoogleLogin from "./googleLogin";
import AppleLoginButton from "./appleLogin";
import { useTranslation } from "react-i18next";
// Import social icons if you are using image assets
// import GoogleIcon from "/images/google-icon.svg";
// import AppleIcon from "/images/apple-icon.svg";

function LoginBuyer() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get("redirect") || "/";
  const Dispatch = useDispatch();
  const { t } = useTranslation();

  // State to manage the active login method (Email or Phone Number)
  const [loginMethod, setLoginMethod] = useState("email");
  // State to manage password visibility (for demonstration)
  const [showPassword, setShowPassword] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  // Define primary colors matching the image
  const primaryPink = "#FF63B5"; // A close match to the button/highlight color
  const lightPink = "rgb(255, 230, 235)"; // A close match to the light pink background

  const validationSchema = Yup.object().shape({
    email: loginMethod == 'email' ? Yup.string()
      .trim()
      .required(t("vaildation.email_required") || "Email address or username is required") : Yup.string().notRequired(),
    password: loginMethod == 'email'
      ? Yup.string()
        .required(t("vaildation.password_required"))
      : Yup.string().notRequired(),
    phone_number: loginMethod == 'email' ? Yup.string().notRequired() : PHONE_VALIDATION
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
      password: '',
      phone_number: ''
    },
    validationSchema: validationSchema,
    validateOnBlur: false,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      setSubmitted(true);
      let formData = new FormData();

      if (loginMethod == 'email') {
        formData.append("email", values.email);
        formData.append("password", values.password);
      } else {
        formData.append("phone_number", values.phone_number);
      }
      formData.append("type", loginMethod);

      setSubmitted(false);
      AuthServices
        .login(formData)
        .then((response) => {
          setSubmitted(true);

          if (response.success) {

            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            // resetForm({ values: "" });
            // setUpdateData(!updateData);
            if (loginMethod == 'email') {
              clearUserSession();
              setLocalKey(ROLE.USER, JSON.stringify(response.data));
              if (response.data.isAdvertiser || response.data.role === ROLE.ADVERTISER) {
                setLocalKey(ROLE.ADVERTISER, JSON.stringify(response.data));
              }
              Dispatch(addProfileData(response.data));

              if (isMissingPhoneNumber(response.data.phone_number)) {
                Swal.fire({
                  icon: "warning",
                  title: "Mobile Number Required",
                  text: "Please add your mobile number to continue.",
                  confirmButtonColor: "var(--primary-400, #ff4081)",
                  confirmButtonText: "Add Mobile Number",
                }).then(() => {
                  navigate('/user/profile-edit');
                });
                return;
              }

              navigate(redirectUrl, { state: { loginSuccessful: true, message: response.message } });
            } else {
              navigate(`../otp?user_id=${response.data.user_id}&login_method=${loginMethod}`);
            }


          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setSubmitted(true);
          console.log("error ====> ", error);
        });
    },
  });

  function handleRememberMe(e) {
    console.log(e.target.checked);
    if (e.target.checked) {
      setSessionKey("remember-me", "true");
    } else {
      removeSessionKey("remember-me");
      Cookies.remove("email");
      Cookies.remove("password");
      // console.log("remvdkjl");
    }
  }

  const forgotPassword = () => {
    navigate('../forgot-password');
  }

  return (
    <section className="py-8 md:py-12 lg:py-16 form-bg">
      <div className="container">
        <h1 className="headings-h1 text-center text-zinc-950 mb-8">
          {/* Login to your account */}
          {t("user.login")}
        </h1>
        <div className="bg-white p-[15px] md:p-[50px] rounded-[10px] max-w-[475px] shadow-[0px_2px_24px_rgba(0,0,0,0.05)] w-full mx-auto border border-zinc-100 w-full">
          <form onSubmit={formik.handleSubmit} className="space-y-5">
            {/* Email/Phone Number Toggle */}
            {/* <div className="flex overflow-hidden w-full gap-[15px] text-base font-medium">
              <button
                type="button"
                className={`flex-1 py-[10px] text-center rounded-[4px] transition-colors duration-200 ${loginMethod === "email"
                    ? "text-white shadow-md"
                    : "text-[#FF63B5]"
                  }`}
                style={{
                  background: loginMethod === "email" ? primaryPink : "#FEF1F8",
                }}
                onClick={() => setLoginMethod("email")}
              >
             
                {t("email")}
              </button>
              <button
                type="button"
                className={`flex-1 py-[10px] text-center rounded-[4px] transition-colors duration-200 ${loginMethod === "phone"
                    ? "text-white shadow-md"
                    : "text-[#FF63B5]"
                  }`}
                style={{
                  background: loginMethod === "phone" ? primaryPink : "#FEF1F8",
                }}
                onClick={() => setLoginMethod("phone")}
              >
         
                {t("phone")}
              </button>
            </div> */}




            {/* Password Field */}
            {
              loginMethod === "email"
                ?
                <>
                  {/* Input Fields */}
                  <div className="form-group">
                    <label htmlFor="email" className="">{t("email_address")} / Username <span className="text-danger">*</span></label>
                    <input
                      id="email"
                      type="text"
                      placeholder="Enter email address or username"
                      className="form-control-custom"
                      // required
                      name="email"
                      value={formik.values.email}
                      onChange={(e) => {
                        const val = e.target.value.toLowerCase().replace(/\s/g, "");
                        formik.setFieldValue("email", val);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <span className="text-danger text-left d-blockerr-spn">
                      {formik.errors.email && formik.touched.email && formik.errors.email}
                    </span>
                  </div>

                  <div className="form-group">
                    <label htmlFor="password" className="">
                      {t("password")} <span className="text-danger">*</span>
                    </label>
                    <div className="relative">
                      <input
                        id="password"
                        type={showPassword ? "text" : "password"}
                        placeholder={t("placeholder.password")}
                        className="form-control-custom !pr-[40px]"
                        name="password"
                        value={formik.values.password}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\s/g, ""); // remove spaces
                          formik.setFieldValue("password", value);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === " ") {
                            e.preventDefault(); // block space key
                          }
                        }}
                        onBlur={formik.handleBlur}
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(prev => !prev)}
                        className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                      >
                        {showPassword ? <img src="/images/eye2.svg" /> : <img src="/images/eye1.svg" />}
                      </button>
                    </div>
                    <span className="text-danger text-left d-blockerr-spn">
                      {formik.errors.password && formik.touched.password && formik.errors.password}
                    </span>
                  </div>
                </>
                :
                <div>
                  <PhoneInput
                    value={formik?.values?.phone_number}
                    name={'phone_number'} placeholder={t("placeholder.phone")} onChange={(e) => { formik.setFieldValue('phone_number', e?.phone_number) }} onBlur={formik.handleBlur}
                  />
                  <span className="text-danger text-left d-blockerr-spn">
                    {formik.errors.phone_number && formik.touched.phone_number && t(formik.errors.phone_number)}
                  </span>
                </div>
            }

            {/* Remember Me and Forgot Password */}
            <div className="flex justify-between items-center text-sm">
              <div className="flex items-center">
                <input
                  id="remember-me"
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-300 accent-pink-500"
                  onChange={(e) => handleRememberMe(e)}
                />
                <label
                  htmlFor="remember-me"
                  className="ml-2 text-[15px] text-gray-950"
                >
                  {t("remember_me")}
                </label>
              </div>
              <a href="#" className="headings-h6 text-[#FF63B5] bold" onClick={forgotPassword}>
                {t("forget_password")}
              </a>
            </div>

            {/* Login Button */}
            <button type="submit" className="btn btn-pri w-full">
              {t("login")}
            </button>

            {/* OR Divider */}
            <div className="relative text-center my-4">
              <span className="relative z-10 inline-block px-4 text-zinc-800 bg-white body-2 medium">
                {t("continue_with")}
              </span>
            </div>

            {/* Social Login Buttons */}
            <div className="flex space-x-3">

              {/* Google Icon Placeholder */}
              {/* <button
                type="button"
                className="flex-1 flex items-center justify-center"
              >
                <img src="/images/google.svg" alt="Google" />
              </button> */}
              <GoogleLogin />


              {/* Apple Icon Placeholder */}
              {/* <button
                type="button"
                className="flex-1 flex items-center justify-center"
              >
                <img src="/images/apple.svg" alt="Apple" />
              </button> */}
              <AppleLoginButton />
            </div>

            {/* Guest User Button */}
            {/* <button
              type="button"
              className="btn btn-outline w-full"
              onClick={() => {
                setLocalKey("isGuest", "true");
                navigate(redirectUrl);
              }}
            >
              {t("guest_user") || "Continue as Guest"}
            </button> */}

          </form>
        </div>
        <div className="mt-8 text-center body-md text-zinc-700">
          {t("account_not_have")}
          <a href="#" className="headings-h6 bold text-[var(--secondary-400)]" onClick={() => navigate('../signup')}>
            {t("sign_up")}
          </a>
        </div>
      </div>
    </section>
  );
}

export default LoginBuyer;
